export default __webpack_public_path__ + "media/images/fancybox/fancy_close-0c6fdab5ad5dc12fd62a027376fffbd4.png";